import {
  addWishlistItemAction,
  copyAnonymousWishlistToWishlistAction,
} from "@/actions/wishlist";
import {
  ANONYMOUS_WISHLIST_ID_NAME,
  ANONYMOUS_WISHLIST_TOKEN_NAME,
} from "@/utils/const";
import { GUEST_WISHLIST_MERGED_STORAGE_KEY } from "@features/auth/const";
import { deleteCookie, getCookie } from "cookies-next";
import {
  clearWishlistFromLocalStorage,
  getWishlistFromLocalStorage,
} from "./localWishlistStorage";

export function clearGuestWishlistMergeState() {
  try {
    sessionStorage.removeItem(GUEST_WISHLIST_MERGED_STORAGE_KEY);
  } catch {}
}

export default async function mergeGuestWishlistOnce({
  uid,
  token,
  locale,
}: {
  uid: string;
  token: string;
  locale: string;
}): Promise<void> {
  try {
    if (sessionStorage.getItem(GUEST_WISHLIST_MERGED_STORAGE_KEY) === uid) {
      return;
    }
  } catch {
    return;
  }

  await copyCookieWishlist({ token, locale });
  await copyLocalStorageWishlist({ token, locale });

  try {
    sessionStorage.setItem(GUEST_WISHLIST_MERGED_STORAGE_KEY, uid);
  } catch {}
}

async function copyCookieWishlist({
  token,
  locale,
}: {
  token: string;
  locale: string;
}) {
  const wishlistId = parseInt(
    getCookie(ANONYMOUS_WISHLIST_ID_NAME)?.toString() ?? "",
    10,
  );
  const wishlistToken = getCookie(ANONYMOUS_WISHLIST_TOKEN_NAME)?.toString();

  if (!wishlistId || !wishlistToken) return;

  try {
    await copyAnonymousWishlistToWishlistAction({
      token,
      locale,
      wishlistId,
      wishlistToken,
    });
  } catch {
    // Duplicates or a stale cookie should not block localStorage merge.
  }

  deleteCookie(ANONYMOUS_WISHLIST_ID_NAME);
  deleteCookie(ANONYMOUS_WISHLIST_TOKEN_NAME);
}

async function copyLocalStorageWishlist({
  token,
  locale,
}: {
  token: string;
  locale: string;
}) {
  const guestWishlist = getWishlistFromLocalStorage();
  const items = guestWishlist.wishlistItems ?? [];

  if (items.length === 0) {
    clearWishlistFromLocalStorage();
    return;
  }

  for (const item of items) {
    if (!item.productId || !item.variantId) continue;
    try {
      await addWishlistItemAction({
        token,
        locale,
        productId: item.productId,
        variantId: item.variantId,
      });
    } catch {
      // Skip duplicates / missing products so the rest of the list still copies.
    }
  }

  clearWishlistFromLocalStorage();
}
